import { _ as _root } from './_root.mjs';

var root = _root;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

var _Symbol = Symbol$1;

export { _Symbol as _ };
